import { Box, Chip, Stack, Typography, useTheme } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';
import { Fragment, isValidElement } from 'react';

import { IChipItem } from 'core/types';
import { Color, Level, Size, Variant } from 'theme/enums';

import { Title, TitleWrapper } from './style';

interface IProps {
  title: string;
  subtitle?: JSX.Element | string;
  chips?: IChipItem[] | JSX.Element[] | (IChipItem | JSX.Element)[];
  buttons?: JSX.Element[];
  wrapperStyle?: SxProps;
}

const PageTitle = ({ title, subtitle, chips, buttons, wrapperStyle }: IProps) => {
  const theme = useTheme();

  return (
    <Stack spacing={1} sx={wrapperStyle}>
      <TitleWrapper>
        <Box display={'flex'} gap={2} alignItems={'center'}>
          <Title>{title}</Title>

          {chips?.map((chipItem: IChipItem | JSX.Element, index: number) => {
            if (isValidElement(chipItem)) {
              return <Fragment key={chipItem.key || index}>{chipItem}</Fragment>;
            }

            const chip = chipItem as IChipItem;

            const chipColor = chip?.color || Color.WARNING;
            const chipVariant = chip?.variant || Variant.SOFT;

            return (
              <Chip
                key={chip.label}
                color={chipColor}
                size={chip?.size || Size.LG}
                variant={chipVariant}
                sx={{
                  height: 'fit-content',
                  ...(chip?.sx || {}),
                  ...(chipColor === Color.PRIMARY &&
                    chipVariant === Variant.SOFT && {
                      color: theme.palette.primary[800],
                      backgroundColor: theme.palette.primary[200],
                    }),
                  ...(chipColor === Color.WARNING &&
                    chipVariant === Variant.SOLID && {
                      color: theme.palette.warning[700],
                    }),
                }}
              >
                {chip.label}
              </Chip>
            );
          })}
        </Box>

        <Box display={'flex'} gap={1}>
          {buttons}
        </Box>
      </TitleWrapper>

      {subtitle && (
        <Typography level={Level.TITLE_MD} color={Color.NEUTRAL} component="div">
          {subtitle}
        </Typography>
      )}
    </Stack>
  );
};

export default PageTitle;
